// Global directives

import Vue from 'vue';

import authorization from './authorization';

Vue.directive('auth', authorization);



// WEBPACK FOOTER //
// ./src/directives/index.js